import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../../redux/actions/authActions";
// import { signInWithEmailLink_ } from "../../redux/actions/authActions";
import { db_firestore } from "../../../firebase/config";
// NAVIGATE
import { useNavigate } from "react-router-dom";
import Slider from "@mui/material/Slider";
import MainButton from "../../../commonComponents/MainButton";
import { fabClasses } from "@mui/material";

const SubscriptionCardCustom = (props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  //   const signOut_rd = (item) => dispatch(signOut(item));

  // const [number_users, set_number_users] = useState(props.data[1].metadata.init_users);
  // const [number_products, set_number_products] = useState(props.data[1].metadata.init_products);
  // const [price, setPrice] = useState(null);
  // useEffect(() => {
  //   if (props.data[1].prices) {
  //     const price_string = props.data[1].prices.priceData.unit_amount.toString();
  //     setPrice(price_string.slice(0, price_string.length - 2));
  //   }
  // }, [props.data[1].prices]);

  return (
    <div className="flex flex-col p-6 w-[300px] h-[460px] text-gray-900 bg-white rounded-lg border border-gray-100 shadow ">
      <div className="flex flex-row justify-between items-baseline align-middle">
        <h3 className="mb-4 text-2xl font-semibold">Premium</h3>
        <div className="flex justify-center items-baseline">
          {/* <span className="mr-2 text-3xl font-extrabold">
            {price &&
              parseFloat(price) +
                (number_users - props.data[1].metadata.init_users) * (props.data[1].name.split(" ")[0] === "Standard" ? 49 : 39) +
                (number_products - props.data[1].metadata.init_products) * (props.data[1].name.split(" ")[0] === "Standard" ? 99 : 79)}
            €
          </span> */}
          {/* <span className="text-gray-500 dark:text-gray-400">/month</span> */}
        </div>
      </div>

      <span className="font-Poppins-SemiBold text-lg my-[15px] text-center mb-[100px] mt-[100px]">{"Solution personnalisée pour vos besoins."}</span>

      <div className={"text-xs h-[35px] w-[200px] rounded-lg pl-[40px] text-white font-Poppins-SemiBold justify-center items-center align-center content-center"}>
        <MainButton
          // disabled={user_info.organization_info.role.access.analyse.write}
          disabled={true}
          callback={(e) => {
            // window.location = "mailto:saad.lachhab@lokalite.io";
            window.open("mailto:contact@lokalite.io&subject=[Lokalité] - Demande d'une solution personnalisée", "_blank");
            // e.preventDefault();
          }}
          title={"Contactez-nous"}
          styleWind={"text-xs"}
        />
      </div>
    </div>
  );
};

export default SubscriptionCardCustom;
